<template>
	<div
		class="nav search-menu-item-info"
		data-testid="globalsearch-section-vehicle"
	>
		{{ formattedVehicleInfo }}
	</div>
</template>

<script>
export default {
	name: 'VueGlobalSearchSectionVehicle',
	props: {
		globalSearchSectionVehicle: {
			type: Object,
			default: undefined
		}
	},
	computed: {
		formattedVehicleInfo() {
			const {
				year,
				makeShort,
				modelShort,
				vin
			} = this.globalSearchSectionVehicle;
			const yearPart = year ? `${year} ` : '';
			const makeShortPart = makeShort ? `${makeShort} ` : '';
			const modelShortPart = modelShort ? `${modelShort} ` : '';
			const hasYearMakeModel = year || makeShort || modelShort;

			let vinPart = '';
			vinPart = vin ? `- ${vin}` : '';

			if (!hasYearMakeModel) vinPart = vin ? `${vin}` : '';

			return `${yearPart}${makeShortPart}${modelShortPart}${vinPart}`;
		}
	}
};
</script>

<style lang="scss" scoped>
.search-menu-item-info {
	margin-top: $gutter-sm;
	font-size: $txt-supporting-font-size;
	color: $menu-list-info-fg;
}
</style>
